<template>
  <div class="pa-2 flex">
    <div class="form-content">
      <v-form id="dealcompany">
        <div class="text-id">ID : {{ infoID }}</div>
        <v-autocomplete
          dense
          outlined
          style="height: 45px; width: 180px !important"
          class="selectmid"
          id="company"
          ref="companySelect"
          label="등록 경영체✽"
          v-model="company"
          :items="companyItems"
          :menu-props="{ top: false, offsetY: true }"
          item-text="name"
          return-object
          @click="comboCompanies"
        />

        <v-text-field dense outlined style="height: 45px; margin-top: 10px !important" :loading="loading" id="company_name" ref="company_name" label="거래처명✽" v-model="company_name" />
        <v-layout class="mt-2">
          <v-text-field
            dense
            outlined
            style="height: 45px; width: 180px; margin-top: 5px; margin-right: 5px !important"
            id="business_no"
            ref="business_no"
            label="사업자/법인 등록번호✽"
            placeholder="사업자 또는 법인 등록번호의 숫자만 입력"
            v-model="business_no"
            @keyup="getRegMask(business_no)"
          />
          <v-text-field dense outlined style="height: 45px; margin-top: 5px" id="ceo_name" ref="ceo_name" label="대표자명✽" placeholder="대표자 또는 담당자 명" v-model="ceo_name" />
        </v-layout>

        <v-layout style="height: 25px; margin-top: -15px">
          <v-checkbox style="width: 100px" color="#3a4f3f" ref="enter" v-model="ckenter" label="입식처"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="cksale" label="출하처"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="ckslaughter" label="도축장"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="ckfeed" label="사료"></v-checkbox>
        </v-layout>

        <v-layout>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="ckmedi" label="약품"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="ckfumi" label="방역"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="ckpackage" label="패키지업체"></v-checkbox>
          <v-checkbox style="width: 100px" color="#3a4f3f" v-model="cketc" label="기타"></v-checkbox>
        </v-layout>

        <div class="info-text" v-show="ckpackage" style="color: gray">
          패키지 업체를 선택 시 비고란에 업체 설명을 기재하세요. <br />
          <span v-show="!infoID"> 패키지 업체 등록 후 API key 발급이 가능합니다. </span>
        </div>

        <div v-show="ckpackage && infoID" class="mt-2">
          <div class="info-text">패키지 업체 API key 발급</div>
          <table class="mt-1">
            <thead>
              <tr>
                <th class="thead_key">API 키</th>
                <th class="thead_del">
                  <v-btn outlined class="add_btn" @click="addKey_modal = true">
                    <v-icon>mdi-key-plus</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="key in api_key" :key="key">
                <td>{{ key }}</td>
                <td>
                  <v-btn
                    class="add_btn"
                    outlined
                    @click="
                      delKey_modal = true;
                      selectedKey = key;
                    "
                    v-show="userName == '조혜린D' || userName == '조혜린' || userName == '이승연' || userName == '이승연D' || userName == '이도헌'"
                  >
                    <v-icon color="gray">mdi-delete-empty</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <v-dialog v-model="addKey_modal" width="400">
          <v-card style="padding: 30px">
            <h4>API 발급</h4>

            <div class="mt-3">{{ company_name }} 의 API KEY를 발급 받으시겠습니까?</div>

            <v-row justify="end" class="mt-3">
              <v-btn class="search_btn" @click="addkey()">발급받기</v-btn>
            </v-row>
          </v-card>
        </v-dialog>

        <v-dialog v-model="delKey_modal" width="400">
          <v-card style="padding: 30px">
            <h4>API 삭제</h4>

            <div class="mt-3">해당 API KEY를 발급 받으시겠습니까?</div>

            <v-row justify="end" class="mt-3">
              <v-btn class="search_btn" @click.stop="deleteKey()">삭제</v-btn>
            </v-row>
          </v-card>
        </v-dialog>

        <v-layout class="mt-3">
          <v-text-field dense outlined disabled class="textfield" id="post_no" ref="post_no" label="우편번호✽" v-model="post_no" onKeyup="this.value=this.value.replace(/[^0-9]/g,'');" maxlength="5" />
          <v-btn text class="search_btn mt-1" @click="openPost()"> 검색 </v-btn>
        </v-layout>

        <div class="mt-2">
          <v-text-field dense outlined disabled style="max-width: 450px" class="textfield" id="address_1st" ref="address_1st" label="기본주소✽" v-model="address_1st" />
        </div>
        <div class="mt-2">
          <v-text-field dense outlined style="max-width: 450px" class="textfield" id="address_last" ref="address_last" label="상세주소(빌딩명,동호수,상호)" v-model="address_last" />
        </div>

        <v-layout style="height: 45px; margin-top: 10px">
          <v-text-field dense outlined style="height: 45px; margin-top: 10px" id="phone1" ref="phone1" label="대표번호✽" placeholder="숫자만 입력" v-model="phone1" @keyup="getPhoneMask(phone1)" />

          <v-text-field
            dense
            outlined
            style="height: 45px; margin-top: 0px"
            class="textfield"
            id="phone2"
            ref="phone2"
            label="연락처"
            placeholder="숫자만 입력"
            v-model="phone2"
            @keyup="getPhone2Mask(phone2)"
          />
        </v-layout>

        <v-layout style="height: 45px; margin-top: 10px">
          <v-text-field dense outlined style="height: 45px; margin-top: 0px" id="email_id" ref="email_id" label="이메일" v-model="email_id" />
          <div class="mt-3">@</div>
          <v-combobox
            dense
            outlined
            style="height: 45px; margin-top: 12px margin-right:50px"
            id="email_host"
            ref="email_host"
            :items="['gmail.com', 'hotmail.com', 'naver.com', 'daum.net']"
            placeholder="항목이 없으면 직접 입력하세요"
            v-model="email_host"
          />
        </v-layout>

        <!-- <v-text-field dense outlined style="height: 45px; width: 200px; margin-top: 10px !important" 
              id="phone" 
              ref="phone" 
              label="전화번호✽" 
              placeholder="숫자만 입력"
              v-model="phone"
              @keyup="getPhoneMask(phone)"
            /> -->

        <v-layout class="mt-1">
          <v-layout style="height: 45px; width: 200px; margin-top: 5px">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined id="dealdate" ref="dealdate" v-model="dealdate" label="거래시작일✽" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker no-title locale="ko-KR" v-model="dealdate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-layout>

          <v-layout style="height: 50px; width: 200px; margin-top: 5px; margin-left: 3px">
            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable id="deldate" ref="deldate" v-model="deldate" label="거래중지일" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker no-title locale="ko-KR" v-model="deldate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-layout>

        <div>
          <v-textarea outlined dense rows="2" name="input-7-4" class="memo-height" label="비고" id="history" ref="history" v-model="history" value="" persistent-hint :hint="hint"></v-textarea>
        </div>

        <v-row justify="center" class="mt-14">
          <v-btn class="rounded-pill elevation-7 normal-btn mr-2 mb-5" :loading="loadingSave" id="save" ref="save" style="height: 35px; width: 100px" type="submit" @click.prevent="save()">
            저장
          </v-btn>
          <v-btn class="rounded-pill elevation-7 new-btn mb-5 mr-2" id="newRegister" ref="newRegister" style="height: 35px; width: 100px" @click="newRegister()"> 새로등록 </v-btn>
        </v-row>
      </v-form>
    </div>

    <div class="list-content">
      <v-layout>
        <v-radio-group dense outlined row style="margin-bottom: -18px" id="selOption" ref="selOption" v-model="selOption">
          <v-radio label="입식처" value="enter" color="blue" @click="listCompanies()"></v-radio>
          <v-radio label="출하처" value="sale" color="green" @click="listCompanies()"></v-radio>
          <v-radio label="도축처" value="slaughter" color="red" @click="listCompanies()"></v-radio>
          <v-radio label="사료" value="feed" color="cyan" @click="listCompanies()"></v-radio>
          <v-radio label="약품" value="medi" color="gray" @click="listCompanies()"></v-radio>
          <v-radio label="방역" value="fumi" color="orange" @click="listCompanies()"></v-radio>
          <v-radio label="패키지업체" value="package" color="pink" @click="listCompanies()"></v-radio>
          <v-radio label="기타" value="etc" color="black" @click="listCompanies()"></v-radio>
          <v-radio label="모두" value="all" color="#3a4f3f" @click="listCompanies()"></v-radio>
        </v-radio-group>
      </v-layout>

      <v-data-table
        dense
        height="600"
        class="mt-2 elevation-3"
        :loading="loadingTable"
        :headers="headers"
        :items="filteredCompanies"
        no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
        id="companies"
        ref="companies"
        @click:row="infoDetail"
        @dblclick:row="selectedBizNo.business_no && infoDetail(selectedBizNo)"
        item-key="id"
        single-select
        :item-class="itemRowBackground"
        fixed-header
        hide-default-footer
        :items-per-page="50000"
        sort-by="company_name"
      >
      </v-data-table>
      <div class="mt-3" style="display: grid; grid-template-columns: 1fr auto 1fr; align-items: center">
        <div style="display: flex; align-items: center">
          <v-autocomplete
            key="searchType"
            dense
            outlined
            hide-details
            class="selectmid search-type-select"
            style="flex: 0 0 140px; height: 45px; margin-right: 8px"
            id="searchType"
            ref="searchType"
            label="검색분류"
            v-model="searchType"
            :items="searchTypeItems"
            :menu-props="{ top: false, offsetY: true }"
            item-text="text"
            item-value="value"
          />
          <v-text-field
            key="searchText"
            dense
            outlined
            hide-details
            class="search-text-field"
            style="flex: 0 0 200px; height: 45px"
            id="searchText"
            ref="searchText"
            v-model="searchText"
            label="검색어"
            append-icon="mdi-magnify"
          />
        </div>
        <v-btn class="rounded-pill elevation-7 normal-btn" style="justify-self: center" @click.prevent="listCompanies()"> 새로고침 </v-btn>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Apis from "@/api/apis";
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

export default {
  name: "newDealComany",
  computed: {
    userName() {
      return this.$store.getters.userName;
    },
    filteredCompanies() {
      const keyword = this.searchText.trim().toLowerCase();
      if (!keyword) {
        return this.companies;
      }
      return this.companies.filter((item) => {
        const value = item[this.searchType];
        return value != null && String(value).toLowerCase().includes(keyword);
      });
    },
  },
  data() {
    return {
      companyItems: [],
      company: {},

      selOption: "all",
      enter: false,
      sale: false,
      slaughter: false,
      feed: false,
      medi: false,
      fumi: false,
      package: false,
      etc: false,

      headers: [
        // { text: '',align: 'center', sortable: false, value: 'actions', width: "10px", groupable: false, class: 'green darken-4 white--text' },
        { text: "상호", align: "left", sortable: true, value: "company_name", width: "120px", class: "green darken-4 white--text" },
        { text: "등록번호", value: "business_no", sortable: true, width: "160px", class: "green darken-4 white--text" },
        { text: "대표", value: "ceo_name", sortable: true, width: "85px", class: "green darken-4 white--text" },
        { text: "전화번호", value: "phone1", width: "130px", class: "green darken-4 white--text" },
        { text: "거래 시작일", value: "dealdate", sortable: false, width: "110px", class: "green darken-4 white--text" },
        { text: "거래 중지일", value: "deldate", sortable: false, width: "110px", class: "green darken-4 white--text" },
        { text: "주소", value: "address_1st", sortable: false, width: "250px", class: "green darken-4 white--text" },
        // { text: '이메일', value: 'email1', sortable: false, width: "30px", class: 'green darken-4 white--text' },
        { text: "비고", value: "history", sortable: false, width: "200px", class: "green darken-4 white--text" },
        // { text: '등록일시', value: 'regdate', sortable: false, width: "120px", class: 'green darken-4 white--text' },
      ],

      api_key: [],

      companies: [],
      loadingTable: false,

      searchType: "company_name",
      searchText: "",
      searchTypeItems: [
        { text: "상호", value: "company_name" },
        { text: "등록번호", value: "business_no" },
        { text: "대표", value: "ceo_name" },
        { text: "전화번호", value: "phone1" },
        { text: "거래 시작일", value: "dealdate" },
        { text: "거래 중지일", value: "deldate" },
        { text: "주소", value: "address_1st" },
        { text: "비고", value: "history" },
      ],

      bizNO_disabled: true,
      infoID: "",

      company_name: "",
      ceo_name: "",
      business_no: "",
      post_no: "",
      ckenter: false,
      cksale: false,
      ckslaughter: false,
      ckfeed: false,
      ckmedi: false,
      ckfumi: false,
      ckpackage: false,
      cketc: false,
      address_1st: "",
      address_last: "",

      phone1: "",
      phone2: "",

      email_id: "",
      email_host: "",
      phone: "",
      dealdate: "",
      deldate: "",
      history: "",
      hint: "",

      // businessDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,

      loading: false,
      loadingSave: false,

      selectedKey: null,
      addKey_modal: false,
      delKey_modal: false,
    };
  },
  created() {
    this.comboCompanies();
    Apis.pageCount(
      {
        page_name: this.$route.name,
        url: this.$route.path,
        division: "pigro",
      },
      () => {
        // 정상처리
        // console.log("pageCount 호출",res);
      },
    ).catch((err) => {
      // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류", err);
    });

    this.listCompanies();
  },

  methods: {
    addkey() {
      Apis.insertAPIkey(
        {
          regcompany_cd: this.company.code,
          company_name: this.company_name.trim(),
          business_no: this.business_no.replace(/[^0-9]/g, ""),
        },
        (res) => {
          // 정상처리
          // console.log("res",res);

          this.api_key.push(res.data);

          this.addKey_modal = false;

          this.$store.commit("resMessage", res.message);
        },
      ).catch((err) => {
        // 개별 API 오류 처리 예제
        console.log("insertAPIkey 호출 오류", err);
      });
    },
    deleteKey() {
      // console.log(key)
      Apis.deleteAPIkey(
        {
          key: this.selectedKey,
        },
        (res) => {
          // 정상처리
          // console.log("res",res);
          this.api_key = this.api_key.filter((k) => k !== this.selectedKey); // ✅ this.selectedKey 사용

          this.delKey_modal = false;
          this.$store.commit("resMessage", res.message);
        },
      ).catch((err) => {
        // 개별 API 오류 처리 예제
        console.log("insertAPIkey 호출 오류", err);
      });
    },
    listCompanies() {
      this.$store.commit("resMessage", "");
      this.loadingTable = true;
      Apis.listDealCompanies(
        {
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
          dealtype: this.selOption,
        },
        (res) => {
          // 정상처리
          // console.log("res",res);
          res.data.forEach((element) => {
            element.business_no = Common.getRegMask(element.business_no);
            element.phone1 = Common.getMask(element.phone1);
            element.phone2 = Common.getMask(element.phone2);

            element.address_1st = element.address_1st + "" + element.address_last;
            element.service = element.service == "5" ? "프리미엄" : "일반";
          });
          this.companies = res.data;
          this.$store.commit("resMessage", res.message);
          this.loadingTable = false;
        },
      ).catch((err) => {
        // 개별 API 오류 처리 예제
        console.log("listCompanies 호출 오류", err);
        this.$router.push("/");
        this.loadingTable = false;
      });
    }, // -----------listCompanies
    selectRow(item, row) {
      row.select(true);
      // console.log("item-",item,"row=,",row)
      this.selectedBizNo = item;
      this.routedBizNo = "";
    },
    infoDetail(value, row) {
      row.select(true);

      this.$store.commit("resMessage", "");
      this.clearData();

      this.loading = true;
      // console.log(value)
      Apis.infoDealCompany(
        {
          id: value.id,
        },
        (res) => {
          if (res.result) {
            this.infoID = value.id;
            this.companyItems.push(res.data.regcompany_cd);
            this.company = res.data.regcompany_cd;
            this.company_name = res.data.company_name;
            this.ceo_name = res.data.ceo_name;
            this.enter = res.data.enter && res.data.enter == "Y" ? true : false;
            this.cksale = res.data.sale && res.data.sale == "Y" ? true : false;
            this.ckslaughter = res.data.slaughter && res.data.slaughter == "Y" ? true : false;
            this.ckfeed = res.data.feed && res.data.feed == "Y" ? true : false;
            this.ckmedi = res.data.medi && res.data.medi == "Y" ? true : false;
            this.ckfumi = res.data.fumi && res.data.fumi == "Y" ? true : false;
            this.ckpackage = res.data.package && res.data.package == "Y" ? true : false;
            this.cketc = res.data.etc && res.data.etc == "Y" ? true : false;
            this.business_no = Common.getRegMask(res.data.business_no);
            this.post_no = res.data.post_no;
            this.address_1st = res.data.address_1st;
            this.address_last = res.data.address_last;

            this.api_key = res.data.apikeys;
            // let email = res.data.email1.split("@",2);
            // this.email_id = email[0];
            // this.email_host = email[1];
            this.phone1 = Common.getMask(res.data.phone1);
            this.phone2 = Common.getMask(res.data.phone2);

            this.enter = res.data.enter == "Y" ? true : false;
            this.dealdate = res.data.dealdate;
            this.deldate = res.data.deldate;
            this.history = res.data.history;
            this.hint = res.data.regdate + "에 등록, " + res.data.chguser + "님이 " + res.data.chgdate + "에 최종 수정";
            this.loading = false;

            this.$store.commit("resMessage", res.message);
          } else {
            this.loading = false;
            alert(res.message);
          }
        },
      ).catch((err) => {
        // API 오류 처리
        console.log("API 호출 오류");
        this.loading = false;
        alert(err);
        // console.log(err)
      });
    },
    loadDaumPostCode() {
      return new Promise((resolve, reject) => {
        if (window.daum && window.daum.Postcode) {
          resolve();
        } else {
          const daumScript = document.createElement("script");
          daumScript.src = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
          daumScript.async = true;

          daumScript.onload = () => resolve();
          daumScript.onerror = () => reject(new Error("Failed to load Daum Postcode API."));
          document.head.appendChild(daumScript);
        }
      });
    },
    itemRowBackground(item) {
      return item.business_no == this.routedBizNo ? "selected" : "";
    },
    openPost() {
      this.loadDaumPostCode()
        .then(() => {
          // console.log('Daum Postcode API loaded.');
          new daum.Postcode({
            oncomplete: (data) => {
              // 1. 주소 결과를 farmData에 저장
              this.post_no = data.zonecode; // 우편번호
              this.address_1st = data.roadAddress; // 기본주소
              // console.log('Address:', data.roadAddress);
            },
          }).open();
        })
        .catch((error) => {
          console.error("Daum Postcode API 로드 실패:", error.message);
        });
    },
    clearData() {
      this.bizNO_disabled = true;
      (this.infoID = ""), (this.business_no = "");
      this.company = "";
      this.company_name = "";
      this.ceo_name = "";
      (this.ckenter = false),
        (this.cksale = false),
        (this.ckslaughter = false),
        (this.ckfeed = false),
        (this.ckmedi = false),
        (this.ckfumi = false),
        (this.ckpackage = false),
        (this.cketc = false),
        (this.post_no = "");
      this.address_1st = "";
      this.address_last = "";
      this.email_id = "";
      this.email_host = "";
      this.phone1 = "";
      this.phone2 = "";

      this.dealdate = "";
      this.deldate = "";
      this.history = "";
      this.hint = "";

      this.api_key = [];
    },
    checkData() {
      if (!this.company.code) {
        this.$refs.companySelect.focus();
        return "등록 경영체를 선택입력하세요";
      }
      if (!this.company_name.trim()) {
        this.$refs.company_name.focus();
        return "거래처명을 입력하세요";
      }
      if (!this.business_no) {
        this.$refs.business_no.focus();
        return "사업자/법인 등록번호를 입력하세요";
      }

      const cleaned = this.business_no.replace(/\D/g, "");

      if (cleaned.length !== 10) {
        this.$refs.business_no.focus();
        return "사업자등록번호는 10자리 숫자여야 합니다";
      }

      if (!Common.checkBizNo(this.business_no) && !Common.checkRegNo(this.business_no)) {
        this.$refs.business_no.focus();
        return "사업자/법인 등록번호가 틀렸습니다.";
      }

      if (!this.ckenter && !this.cksale && !this.ckslaughter && !this.ckfeed && !this.ckmedi && !this.ckfumi && !this.cketc && !this.ckpackage) {
        this.$refs.business_no.focus();
        return "거래유형중 하나 이상을 선택하세요";
      }
      if (!this.post_no) {
        this.$refs.post_no.focus();
        return "우편번호를 입력하세요";
      }
      if (!this.address_1st.trim()) {
        this.$refs.address_1st.focus();
        return "기본주소를 입력하세요";
      }
      if (!this.phone1.trim()) {
        this.$refs.phone1.focus();
        return "대표번호를 입력하세요";
      }
      if (!this.dealdate) {
        this.$refs.dealdate.focus();
        return "거래시작일을 입력하세요";
      }
      return "";
    },
    save() {
      // console.log("checkdata", this.checkData());
      this.$store.commit("resMessage", "");

      let msgCheckdata = this.checkData();
      if (msgCheckdata) {
        this.$store.commit("resMessage", msgCheckdata);
        // alert(msgCheckdata);
        return;
      }
      this.loadingSave = true;
      if (this.infoID) {
        // console.log("업데이트");
        Apis.updateDealCompany(
          {
            id: this.infoID,
            regcompany_cd: this.company.code,
            business_no: this.business_no.replace(/[^0-9]/g, ""),
            company_name: this.company_name.trim(),
            ceo_name: this.ceo_name.trim(),
            enter: this.ckenter ? "Y" : "",
            sale: this.cksale ? "Y" : "",
            slaughter: this.ckslaughter ? "Y" : "",
            feed: this.ckfeed ? "Y" : "",
            medi: this.ckmedi ? "Y" : "",
            fumi: this.ckfumi ? "Y" : "",
            package: this.ckpackage ? "Y" : "",
            etc: this.cketc ? "Y" : "",
            post_no: this.post_no,
            address_1st: this.address_1st.trim(),
            address_last: this.address_last.trim(),
            email1: this.email_id.trim() + "@" + this.email_host,
            email2: "",
            phone1: this.phone1.replace(/[^0-9]/g, ""),
            phone2: this.phone2.replace(/[^0-9]/g, "") || "",
            dealdate: this.dealdate,
            deldate: this.deldate,
            history: this.history.trim(),
            etc1: "",
            etc2: "",
            etc3: "",
          },
          (res) => {
            if (res.result) {
              this.$store.commit("resMessage", res.message);
              this.loadingSave = false;

              this.listCompanies();

              this.clearData();
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          },
        ).catch((err) => {
          // API 오류 처리
          this.loadingSave = false;
          console.log("API 호출 오류");
          alert(err);
          // console.log(err)
        });
      } else {
        // console.log("인서트",this.email_host.trim());
        Apis.insertDealCompany(
          {
            regcompany_cd: this.company.code,
            company_name: this.company_name.trim(),
            ceo_name: this.ceo_name.trim(),
            business_no: this.business_no.replace(/[^0-9]/g, ""),
            enter: this.ckenter ? "Y" : "",
            sale: this.cksale ? "Y" : "",
            slaughter: this.ckslaughter ? "Y" : "",
            feed: this.ckfeed ? "Y" : "",
            medi: this.ckmedi ? "Y" : "",
            fumi: this.ckfumi ? "Y" : "",
            package: this.ckpackage ? "Y" : "",
            etc: this.cketc ? "Y" : "",
            post_no: this.post_no,
            address_1st: this.address_1st.trim(),
            address_last: this.address_last.trim(),
            email1: this.email_id.trim() + "@" + this.email_host,
            email2: "",
            phone1: this.phone1.replace(/[^0-9]/g, ""),
            phone2: this.phone2.replace(/[^0-9]/g, "") || "",
            dealdate: this.dealdate,
            deldate: this.deldate,
            history: this.history.trim(),
            etc1: "",
            etc2: "",
            etc3: "",
          },
          (res) => {
            if (res.result) {
              // 정상 등록
              this.$store.commit("resMessage", res.message);
              this.loadingSave = false;
              this.clearData();
              this.listCompanies();
            } else if (res.resultCode == "E124") {
              // 등록번호 중복
              if (confirm(res.message + "기 등록된 사업자에 거래유형을 추가 하시겠습니까?")) {
                this.infoDetail({ company_cd: res.data.regcompany_cd, business_no: res.data.business_no });
                this.loadingSave = false;
                return;
              } else {
                this.loadingSave = false;
                return;
              }
            } else this.loadingSave = false;
            alert(res.message);
          },
        ).catch((err) => {
          // API 오류 처리
          this.loadingSave = false;
          console.log("API 호출 오류");
          alert(err);
          // console.log(err)
        });
      }
    },

    comboCompanies() {
      Apis.comboCompanies(
        {
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
          new_version: true,
        },
        (res) => {
          if (res.result) {
            this.companyItems = [];

            // console.log(res.data);
            for (let i in res.data) {
              this.companyItems.push(res.data[i].company);
            }
          } else {
            alert(res.message);
          }
        },
      ).catch((err) => {
        // API 오류 처리
        console.log("API 호출 오류", err);
        alert(err);
      });
    },

    newRegister() {
      this.clearData();
      this.bizNO_disabled = false;
      this.$refs.companySelect.focus();
      this.$store.commit("resMessage", "새로 등록 준비가 되었습니다.");
    },
    listVue() {
      this.$router.push("/farminfo/listdealcompanies");
    },
    getPhoneMask(val) {
      this.phone1 = Common.getMask(val);
      // this.phone2 = Common.getMask(val)
    },
    getPhone2Mask(val) {
      this.phone2 = Common.getMask(val);
      // this.phone2 = Common.getMask(val)
    },
    getRegMask(val) {
      // let res = Common.getRegMask(val)
      this.business_no = Common.getRegMask(val);
    },
  },
};
// 01-06
</script>

<style lang="scss" scoped>
@import "./style/info_style.scss";
// .flex{
//   display: flex;
//   justify-content: center;
// }

.info-text {
  font-size: 0.85rem;
  letter-spacing: -0.75px;
}
.form-content {
  background-color: white;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
  margin-right: 10px;
}
.list-content {
  max-width: 70%;
}
@media screen and (max-width: 820px) {
  .flex_mobile {
    flex-wrap: wrap;
  }
  .dataTable {
    width: 100% !important;
  }
}
.dataTable {
  width: 50%;
}

.v-data-table::v-deep {
  thead.v-data-table-header tr {
    th {
      background-color: #436251 !important;
      color: white !important;
      font-size: 13px;
      height: 40px !important;
    }
  }
}
.normal-btn {
  background-color: #3a4f3f !important;
  color: white;
  width: 100px;
  height: 45px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
}
.new-btn {
  color: #3a4f3f !important;
  width: 100px;
  height: 45px !important;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: -0.5px;
  border-color: transparent;
  background-color: rgb(248, 248, 248) !important;
}
.dialog-btn {
  color: white !important;
  font-size: 12pt;
  font-weight: bold !important;
  background-color: #88191a !important;
}

.text-id {
  color: rgb(155, 152, 152);
  font-size: 12px;
}

table {
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  font-size: 14px;
  width: 100%;
}

th,
td {
  padding: 5px;
  border: 1px solid #e0e0e0;
  text-align: left;
  text-align: center;
}

th {
  background-color: #f5f5f5;
  font-weight: 600;
}

th:first-child,
td:first-child {
  width: 70%;
}

tr:hover {
  background-color: #e1e1e1;
}
.add_btn {
  height: 30px !important;
  border: none !important;
}

.search-text-field {
  ::v-deep .v-input__slot {
    height: 45px !important;
    align-items: center !important;
  }
  ::v-deep .v-text-field__slot {
    align-items: center;
    height: 100%;
  }

  ::v-deep .v-input__append-inner {
    margin-top: 0 !important;
    align-self: center;
  }
}

.search-type-select {
  ::v-deep .v-input__slot,
  ::v-deep .v-input__control {
    height: 45px !important;
    border: none !important;
  }
}
</style>
